import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"

import Header from "./rw_header"
import "./layout.css"

const Layout = ({ children }) => (
  <React.Fragment>
        <Header />
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0,
          }}
        >
          <main>{children}</main>
          <footer>
            <div style={{borderStyle: "solid", borderColor: "black", borderWidth: "5px 0", padding:"25px" }}>
              <h3>TERMS OF USE</h3>
              <p style={{lineHeight: "1.8"}}>
              Republic Waterfowl and its officers and owners, attempts to make the information on this website as timely and accurate as possible, 
              but makes no claims, or guarantees about the accuracy or completeness of information on this site, and expressly disclaims liability 
              for errors and omissions in the contents.  We do not guarantee all information is up to date.  No warranty of any kind, implied, 
              expressed, or statutory, is given with respect to the contents of this website or its links to other Internet resources.  
              Confirm all information with local authorities, property owners and property managers prior to entering onto property or hunting.
              </p>
              <p>If you'd like to provide updated information on a hunting location, please contact us <Link to="/contact">here</Link></p>
            </div>
            <p style={{textAlign:"center", margin:"2rem 0"}}>© 2017 Republic Waterfowl</p>
            {/* |
            © {new Date().getFullYear()}, Built with
            {` `}
            <a href="https://www.gatsbyjs.org">Gatsby</a> */}
          </footer>
        </div>
      </React.Fragment>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
